if (!window.bpPaymentCopyBound) {
  window.bpPaymentCopyBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-payment-copy]');
    if (!button || button.disabled) return;
    const status = button.closest('.bp-payment').querySelector('[data-payment-status]');
    const original = button.innerHTML;
    button.disabled = true;
    try {
      await navigator.clipboard.writeText(button.dataset.paymentCopy);
      button.textContent = 'Copied';
      button.classList.add('copied');
      status.textContent = 'Bank detail copied to clipboard.';
    } catch {
      status.textContent = 'Unable to copy automatically. Please select and copy the bank detail.';
    }
    window.setTimeout(() => {
      button.innerHTML = original;
      button.classList.remove('copied');
      button.disabled = false;
    }, 1500);
  });
}
